import type { AdminDanceSummary } from "@recital-master/shared";

export const INITIAL_TOP_DANCE_COUNT = 15;

export function visibleTopDances(
  dances: AdminDanceSummary[],
  showAll: boolean
): AdminDanceSummary[] {
  return showAll ? dances : dances.slice(0, INITIAL_TOP_DANCE_COUNT);
}
